interface TopicItem {
  label: string;
  count: string;
  hot: boolean;
}

const topics: TopicItem[] = [
  { label: '顶流塌房', count: '356万讨论', hot: true },
  { label: '综艺翻车现场', count: '289万讨论', hot: true },
  { label: '网红互撕', count: '245万讨论', hot: true },
  { label: '明星恋情曝光', count: '198万讨论', hot: true },
  { label: '商界秘闻', count: '176万讨论', hot: false },
  { label: '选秀黑幕', count: '158万讨论', hot: false },
  { label: '剧组内斗', count: '132万讨论', hot: false },
  { label: '代言翻车', count: '119万讨论', hot: true },
  { label: '隐婚生子', count: '98万讨论', hot: false },
  { label: '人设崩塌', count: '87万讨论', hot: false },
  { label: '跨界风波', count: '65万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            全网吃瓜群众正在热议的话题标签，点击探索你感兴趣的大瓜
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                item.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-100 border-background-200 text-foreground-600 hover:border-background-300 hover:bg-background-200/50'
              }`}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              {item.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              )}
              <span>{item.label}</span>
              <span className={`text-xs ${item.hot ? 'text-primary-400' : 'text-foreground-400'}`}>
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}